import BaseService from '../../BaseService';

class PaymentMethodService extends BaseService {
    getAll = () => this.get('/warehouse/paymentMethod/list');

    getOne = (id) => this.get(`/warehouse/paymentMethod/${id}`);

    deleteOne = (id) => this.delete(`/warehouse/paymentMethod/${id}`);

    addPaymentMethod = (data) => this.post('/warehouse/paymentMethod', data);

    editPaymentMethod = (id, data) => this.put(`/warehouse/paymentMethod/${id}`, data);
}

export default new PaymentMethodService();